import dClient from "../../Components/api/reduxLoaderApi";
import {setCategories, setCurrentCategory} from "./slice";
import failStatus from "../../Components/utils/failStatus";
import {notification} from "../../Components/functions/notification/notificationFunction";
import React from "react";
import {getProducts} from "../product/thunks";


export const getCategories = (x, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `category`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(setCategories(res.data.categories));
    // return callback && callback(res.data.product.attributes);
};

export const getCategoriById = (id, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `category/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(setCurrentCategory(res.data.category));
    // return callback && callback(res.data.product.attributes);
};

export const createCategory = (data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `category`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
};

export const editCategory = (category_id, data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `category/${category_id}`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
};

export const deleteCategory = ({ category_id }, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'delete',
        `category/${category_id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res)) return '';
    dispatch(notification("success", "", <h3>با موفقیت حذف شد</h3>, false))
    return callback && callback(res);
};